import React from "react";

export default class Modal extends React.Component {
  constructor() {
    super();
    this.scrollLockInterval = null;
    this.toggleScrollLock = this.toggleScrollLock.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    this.scrollLockInterval = setInterval(this.toggleScrollLock, 100);
  }

  componentWillUnmount() {
    if (this.scrollLockInterval) clearInterval(this.scrollLockInterval);
    if (typeof window === "undefined" || !window.app) return;
    window.app.enableScrolling();
  }

  toggleScrollLock() {
    if (typeof window === "undefined" || !window.app) return;
    if (this.props.show) window.app.disableScrolling();
    else window.app.enableScrolling();
  }

  handleClose() {
    if (this.props.onClose) this.props.onClose();
  }

  render() {
    const {
      children,
      show,
      title,
      message,
      messageAlignment,
      dismissible,
      lockOverlay,
      buttons
    } = this.props;
    const showClass = show ? " show" : "";

    return (
      <div>
        <div
          className={`modal-overlay${showClass}`}
          onClick={
            !lockOverlay && dismissible
              ? this.handleClose
              : e => {
                  e.preventDefault();
                  e.stopPropagation();
                }
          }
        />
        <div className={`modal-container${showClass}`}>
          <div className="modal-content">
            {title && <h2 className="modal-title">{title}</h2>}
            {!!message && (
              <div
                className={`modal-body align-${messageAlignment}${
                  title ? "" : " expand"
                }`}
                dangerouslySetInnerHTML={{ __html: message }}
              />
            )}
            {!!children && (
              <div className={`modal-body${title ? "" : " expand"}`}>
                {children}
              </div>
            )}
            {!!buttons && (
              <div className="modal-buttons">
                {buttons.map(({ text, path, primary }) => (
                  <a
                    className={`btn btn-rounded${
                      primary ? " btn-primary" : ""
                    }`}
                    href={path}
                    {...(path.match(/^http/i)
                      ? { target: "_blank", rel: "noopener noreferrer" }
                      : null)}
                  >
                    {text}
                  </a>
                ))}
              </div>
            )}
          </div>
          {dismissible && (
            <button
              className="modal-close btn close"
              onClick={this.handleClose}
            >
              Close
            </button>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/modal.js